module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.100b38fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-Light.ttf
// module id = 3297
// module chunks = 68